<div>
	@if (mediaUrl) {
		<audio
			#audioElement
			[src]="mediaUrl"
			id="audioTag"
			preload="metadata"
			draggable="false"
			[mediaIsPlaying]="isPlaying"
			[autoplay]="isPlaying"
			[loop]="isLooping"
			[volume]="isValidVolume(volume) ? volume : 1"
			(timeupdate)="handleTimeUpdate()"
		></audio>
	}

	<div style="text-align: center; vertical-align: middle; font-size: 300pt; width: 100%; height: 100%">
		@if (volume > 0.9) {
			<i class="fa fa-volume-up"></i>
		}
		@if (volume > 0.5 && volume <= 0.9) {
			<i class="fa fa-volume"></i>
		}
		@if (volume > 0 && volume <= 0.5) {
			<i class="fa fa-volume-down"></i>
		}
		@if (volume === 0) {
			<i class="fa fa-volume-off"></i>
		}
	</div>
</div>
